import type { FuseTable } from "@szerviz/core";

/**
 * Demo data of the fuse sheet (Škoda Octavia II, from the public sources listed): what the
 * in memory store "finds" in the fuse lookup (tests, demo, help screenshots). Not customer data.
 */
const box = (rows: [string, string][]) => rows.map(([amp, what], i) => ({ no: String(i + 1), amp, what }));

export const DEMO_FUSE_TABLE: FuseTable = {
  years: "2004–2013, ferdehátú és kombi, benzin és dízel",
  boxes: [
    { name: "Utastéri biztosítéktábla", location: "A műszerfal végén, a vezető oldalán, a védőfedél mögött.", fuses: box([
      ["10", "Diagnosztikai aljzat, motorvezérlő, üzemanyag szivattyú"],
      ["5", "ABS / ESP vezérlő"],
      ["5", "Légzsákok"],
      ["5", "Fűtés, klíma, tolatólámpa"],
      ["5", "Fényszóró magasság állító"],
      ["5", "Műszerfal, automata váltó vezérlő, elektromos szervó, parkolóradar"],
      ["", ""],
      ["", ""],
      ["", ""],
      ["", ""],
      ["", ""],
      ["10", "Központi zár vezérlő"],
      ["10", "Külső világítás vezérlő, féklámpák"],
      ["5", "Automata váltó vezérlő, választókar zár"],
      ["7,5", "Belső világítás vezérlő"],
      ["10", "Klímaberendezés"],
      ["", "extra felszereltség"],
      ["5", "Parkolóradar érzékelők"],
      ["5", "Vonóhorog vezérlő"],
      ["5", "Emelkedőn elindulást segítő"],
      ["", ""],
      ["40", "Klíma ventilátor"],
      ["30", "Első elektromos ablakok"],
      ["15", "Szivargyújtó"],
      ["25/30", "Hátsó ablakfűtés, állófűtés"],
      ["20", "12 V aljzat a csomagtérben"],
      ["15", "Üzemanyag szivattyú relé, befecskendezők"],
      ["", "extra felszereltség"],
      ["10", "Motorvezérlő"],
      ["20", "Automata váltó vezérlő"],
      ["20", "Fék vákuumszivattyú"],
      ["30", "Hátsó elektromos ablakok"],
      ["25", "Elektromos tolótető"],
      ["20", "Komfort vezérlő"],
      ["5", "Riasztó"],
      ["20", "Fényszórómosó"],
      ["20", "Első ülésfűtés"],
      ["30", "Hátsó ülésfűtés"],
      ["", ""],
      ["40", "Fűtés ventilátor"],
      ["15", "Hátsó ablaktörlő"],
      ["15", "Szélvédő mosó"],
      ["15", "Vonóhorog"],
      ["20", "Vonóhorog"],
      ["15", "Vonóhorog"],
      ["5", "Fűthető mosófúvókák"],
      ["5", "Állófűtés relé"],
      ["", ""],
      ["5", "Világítás kapcsoló"],
    ]) },
    { name: "Motortéri biztosíték- és relédoboz", location: "A motortér bal oldalán, védőfedél alatt; biztosítékok és relék, valamint a nagyáramú olvadóbiztosítékok.", fuses: box([
      ["", ""],
      ["5", "Kormánykapcsolók"],
      ["5", "Diagnosztikai aljzat"],
      ["30", "ABS hidraulika egység"],
      ["15", "Automata váltó vezérlő"],
      ["5", "Műszerfal"],
      ["", ""],
      ["15", "Audiorendszer"],
      ["5", "Telefon"],
      ["5", "Motorvezérlő relé ellátás"],
      ["20", "Állófűtés vezérlő"],
      ["5", "Adatbusz (gateway) vezérlő"],
      ["15", "Motorvezérlő"],
      ["20", "Gyújtás"],
      ["5/15", "Lambdaszonda, üzemanyag szivattyú relé, izzítás relé"],
      ["30", "ABS vezérlő"],
      ["15", "Kürt"],
      ["30", "Hangrendszer erősítő"],
      ["30", "Ablaktörlő"],
      ["", ""],
      ["15", "Lambdaszonda"],
      ["5", "Fék- és kuplungpedál kapcsoló"],
      ["5/10/15", "Szekunder levegő szivattyú, nagynyomású szivattyú, légtömegmérő"],
      ["10", "EGR szelep"],
      ["30", "Jobb fényszóró"],
      ["30", "Bal fényszóró"],
      ["40", "Szekunder levegő szivattyú, izzítás"],
      ["40", "Önindító"],
      ["50", "Akkumulátor ellátás (30-as kapocs)"],
      ["50", "X kapocs (indításkor lekapcsolt fogyasztók)"],
    ]) },
  ],
  relays: [
    { position: "Motortér R1", what: "Hűtőventilátor relé" },
    { position: "Motortér R2", what: "Automata váltó relé" },
    { position: "Motortér R3", what: "Feszültségellátás relé (15)" },
    { position: "Utastér, 4. hely", what: "Üzemanyag szivattyú relé (J17 dízel / J643 egyes benzines)" },
    { position: "Utastér, 3. hely", what: "Indító relé 1 (J906)" },
    { position: "Utastér, D4", what: "Indító relé 2 (J907)" },
    { position: "Utastér, D2.1", what: "Kürt relé (J4)" },
    { position: "Utastér, D5.1", what: "Fényszórómosó relé (J39)" },
  ],
  sources: [
    { url: "https://fuseandrelay.com/skoda/a5-octavia.html", role: "main" },
    { url: "https://fuseboxinfo.com/index.php/cars/57-skoda/4066-skoda-octavia-2012-fuses", role: "compared" },
    { url: "https://www.manualslib.com/manual/829549/Skoda-Octavia.html?page=254", role: "compared" },
  ],
};
